var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-carousel',_vm._g(_vm._b({ref:_vm.id,staticClass:"nan-carousel"},'b-carousel',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }